import { useEffect, useState } from "react"
import "./skeleton.css"

export interface ChatMessageSkeletonProps {
    width: number,
    alignment: string
}

export const ChatMessageSkeleton: React.FC<ChatMessageSkeletonProps> = ({ width, alignment }) => {

    const [alignItems, setAlignItems] = useState(Math.random() < 0.5 ? "left" : "right");


    return (
        <div className={`${alignItems == "left" ? "items-start" : "items-end flex-row-reverse"} flex flex-row items-baseline w-full gap-2 py-1`}>
            <div className="skeleton_shine w-[30px] h-[30px] rounded-full">
            </div>
            <div style={{ width: `${Math.floor(Math.random() * 65)}%` }} className={`${alignItems == "left" ? "items-start" : "items-end"} flex flex-col gap-2 min-w-[80px] max-w-[65%] lg:max-w-[50 %] rounded-xl p-2`}>
                <div className={`skeleton_shine w-full h-[30px] rounded-xl`}></div>
                <div className={`skeleton_shine  text-xs w-[40px] h-[15px] rounded-xl`}></div>
            </div>
        </div>
    )
}